import { setupStringLocale } from '../locales/i18n';
import { setupDateLocale } from './date-utils';

export type LocaleCode = 'cs' | 'en-US';

export function changeLocale(localeCode: LocaleCode) {
  window.localStorage.setItem('locale', localeCode);
  setupStringLocale(localeCode);
  setupDateLocale(localeCode);
}

export function getLocaleCode() {
  return window.localStorage.getItem('locale') || 'cs';
}
